<div class="content p-3">
    <div class="row my-2" *ngFor="let package of userPackages">
        <div class="col-1 ml-2">
            <p class="color-valyrianSteel">{{package.Activated ? "&#x2714;": "N/A" }}</p>
        </div>
        <div class="col-3">
            <p class="color-whaleTail">{{package.PackageName}}</p>
        </div>
    </div>
</div>
